import {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import CardInfo from './cardInfo/index'
import { IResTransactionRecord } from '@/api/account/interface'
import { useRequest } from 'ahooks'
import { getAccountTransactionRecord } from '@/api/account'
import MeEmpty from '@/components/MeEmpty'
import LoadingCom from '@/components/LoadingCom'

interface IProps {
  address: string
  activeValue: string
  checkinRecordsTab: 'hub' | 'rollapp_checkin'
  pageParams: {
    offset: number
    limit: number
  }
  setTotal: (total: number) => void
  setLoading: (loading: boolean) => void
  nextKey: MutableRefObject<string>
  setNextKeyData: Dispatch<SetStateAction<string>>
  offsetKey: MutableRefObject<string>
  keyArray: MutableRefObject<{
    [key: number]: string
  }>
  currentGroupIndex: MutableRefObject<number>
  offsetKeyArray: MutableRefObject<{
    [key: number]: string
  }>
  groupSize: MutableRefObject<number>
}
const DetailTransitionList = ({
  address,
  activeValue,
  checkinRecordsTab,
  pageParams,
  setTotal,
  setLoading,
  nextKey,
  setNextKeyData,
  offsetKey,
  keyArray,
  currentGroupIndex,
  offsetKeyArray,
  groupSize,
}: IProps) => {
  const listParams = {
    address,
    limit: pageParams.limit,
    offset: pageParams.offset,
  }

  const [accountTransactionRecordList, setAccountTransactionRecordList] = useState<
    IResTransactionRecord[]
  >([])

  /** 参数组装 */
  const getPageParams = () => {
    const params: any = {
      offset: pageParams.offset,
      limit: pageParams.limit,
      address,
    }
    if (keyArray.current[currentGroupIndex.current]) {
      params.key = keyArray.current[currentGroupIndex.current]
    }
    console.log('offsetKeyArray', offsetKeyArray)
    if (offsetKeyArray.current[currentGroupIndex.current] && pageParams.offset > 0) {
      params.offset_key = offsetKeyArray.current[currentGroupIndex.current]
    }
    return params
  }

  const { loading, run } = useRequest(() => getAccountTransactionRecord(getPageParams()), {
    manual: true,
    onSuccess: (res) => {
      setAccountTransactionRecordList(res?.transaction || [])
      setTotal(res?.group_data || 0)
      // 设置下一组key
      nextKey.current = res.next_key || ''
      setNextKeyData(res.next_key || '')
      offsetKeyArray.current[currentGroupIndex.current] = res.offset_key || ''
      // 设置当前组offsetKey
      offsetKey.current = res.offset_key || ''
      if (currentGroupIndex.current === 0 && res.next_key) {
        groupSize.current = Number(res.group_data)
      }
    },
  })

  useEffect(() => {
    run()
  }, [pageParams, run, address, currentGroupIndex])

  useEffect(() => {
    setLoading(loading)
  }, [loading, setLoading])

  return (
    <>
      {activeValue === '0' && checkinRecordsTab === 'hub' && (
        <>
          {loading && <LoadingCom />}
          {!loading && accountTransactionRecordList.length === 0 && <MeEmpty />}
          {accountTransactionRecordList.map((item) => {
            return (
              <CardInfo
                address={address}
                cardData={item}
                key={`detailTransitionList${item.hash}`}
              />
            )
          })}
        </>
      )}
    </>
  )
}

export default DetailTransitionList
